import AboutImage from "../../assets/about.jpg";
import data from "./data";
import Card from "../../components/Card";
import "./about.css";

const About = () => {
  return (
    <section id="about">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="About" loading="lazy" />
          </div>
        </div>
        <div className="about__right">
          <h2>About Me</h2>
          <br />
          <p>
            Hello, I'm Joseph Attard Fava, a dedicated software developer
            specializing in backend technologies, with a focus on C# and .NET.
            With over 10 years of experience in the Maltese iGaming and
            financial sectors, I bring a deep understanding of developing
            scalable and high-performance systems.
          </p>
          <p>
            I am committed to continuous learning and self-improvement, always
            seeking new opportunities to enhance my skills. In addition to my
            backend expertise, I enjoy exploring frontend technologies in my
            spare time, with a particular interest in React and Progressive Web
            Apps. Outside of my professional pursuits, I have a variety of
            hobbies, including the below.
          </p>

          <div className="about__cards">
            {data.map((item) => (
              <Card key={item.id} className="about__card">
                <span className="about__card-icon">{item.icon}</span>
                <h5>{item.title}</h5>
                <small>{item.desc}</small>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
